/* /preview/hero — private preview of the new landing hero video.
   Approve here before we drop it into the real Landing.jsx.
*/
import HeroVideo from "../../components/HeroVideo";
import { VerqoLockup } from "../../components/VerqoLockup";

export default function HeroPreview() {
  return (
    <div className="min-h-screen bg-white">
      {/* Slim top nav — matches marketing site */}
      <div className="border-b border-slate-200/80 bg-white/95 backdrop-blur">
        <div className="max-w-6xl mx-auto px-6 h-14 flex items-center justify-between">
          <VerqoLockup size="sm" />
          <div className="text-[10.5px] uppercase tracking-[0.24em] text-slate-500 mono">
            Preview · not yet live
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-6 py-12 md:py-16">
        <div className="text-[10.5px] uppercase tracking-[0.24em] text-lime-600 mono">
          Landing hero preview
        </div>
        <h1 className="mt-2 text-4xl md:text-5xl font-semibold tracking-tight text-slate-900 max-w-3xl leading-[1.05]">
          Wholesale banking, built for buyers and sellers.
        </h1>
        <p className="mt-4 text-lg text-slate-600 max-w-2xl">
          Buy, sell, get paid, ship — instantly. Verqo is the operating system every wholesaler has been asking for.
        </p>

        <div className="mt-10">
          <HeroVideo
            className="aspect-video max-w-4xl border border-slate-200 shadow-xl"
            title="Watch the Verqo story · 3 min"
            testid="preview-hero-video"
          />
        </div>

        <div className="mt-6 text-sm text-slate-500 max-w-2xl">
          <strong className="text-slate-700">How this works on the live site:</strong> autoplays muted on load,
          shows a subtle "Click to unmute" overlay on hover, unmutes + restarts from 0 on click. When the sound
          version ends it silently loops the muted ambient version.
        </div>
      </div>
    </div>
  );
}
